import * as React from 'react';
import { Tabs } from '../../primitives/tabs/tabs';
import { Container } from '../../primitives/container/container';
import { namespacedClassnames } from '../../common/namespace-classes';
export var TabsContainer = function (props) {
    var handleTabChange = function (selectedTabKey) {
        props.onChange(selectedTabKey);
    };
    var classNames = namespacedClassnames('tabs-container', props.className);
    return (React.createElement("div", { className: classNames },
        React.createElement(Container, null,
            React.createElement(Tabs, { items: props.tabItems, size: props.tabSize, onChange: handleTabChange, selected: props.selected }),
            props.children)));
};
//# sourceMappingURL=tabs-container.js.map